/* eslint-disable */
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import store from "../store/store";
import "whatwg-fetch";

// Vue Components Views
import gameComponent from "./components/game-component";
import faqComponent from "./components/faq-component";

// Utils
import { Tabs, Tab } from "vue-tabs-component";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);

Raven.config("https://2af4ea2a813d44b19f16f22c7ff0ba32@sentry.io/297355")
  .addPlugin(RavenVue, Vue)
  .install();

// Vue App
var app = new Vue({
  el: "#coin-flip-app",
  store,
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      labels: "getLabels",
      targetGroup: "getTargetGroup",
      isLoggedIn: "isLoggedIn",
      getUserID: "getUserID",
      language: "getLanguage"
    })
  },
  methods: {
    ...mapActions(["loadLabels", "setLoading"])
  },
  mounted() {
    const loaders = [store.dispatch("loadLabels")];
  

    if (this.isLoggedIn) {
      var startScreen = document.querySelector(".c-start");
      
      if(startScreen) {
        location.reload();
      }
      loaders.push(store.dispatch("loadUser"));
      const id = this.getUserID;
      Raven.setUserContext({
        id
      });
    }

    const feBindings = () => {
      var termsOpen = window.promo ? window.promo.termsOpen : false;
      var regsOpen = window.promo ? window.promo.legalOpen : true;

      function doesElementExist(el) {
        var existCheck = document.getElementsByClassName(el);
        if (existCheck.length > 0) {
          setAccordion("c-terms");
          if (document.getElementsByClassName("c-uk-regs").length > 0) {
            setAccordion("c-uk-regs");
          }
        } else {
          setTimeout(function() {
            doesElementExist(el);
          }, 500);
        }
      }

      function setAccordion(el) {
        var base = document.getElementsByClassName(el)[0];
        var accTitle = base.getElementsByClassName("c-accordion__title")[0];

        base.style.display = "";

        if (el === "c-terms" && termsOpen) {
          accTitle.classList.add("m--active");
        }

        if (el === "c-uk-regs" && regsOpen) {
          accTitle.classList.add("m--active");
        }
      }

      function handleAccClick(e) {
        var thisClick = e.target;
        if (thisClick.classList.contains("c-accordion__title") > 0) {
          e.target.classList.toggle("m--active");
        }
      }

      document.removeEventListener("click", handleAccClick);

      if (!document.body.classList.contains("coinBound")) {
        document.addEventListener("click", handleAccClick);
        document.body.classList.add("coinBound");
      }

      doesElementExist("c-terms");
    };

    if (!this.termsBound) feBindings();

    Promise.all(loaders).then(() => {
      this.setLoading(false);
    });
  }
});



// WEBPACK FOOTER //
// ./app/js/app.js